import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { CredibilitySection } from '../components/CredibilitySection';
import { AudienceSection } from '../components/AudienceSection';
import { TransformationSection } from '../components/TransformationSection';
import { FAQSection } from '../components/FAQSection';
import { ExpectationNoteSection } from '../components/ExpectationNoteSection';
import { PreCloseSection } from '../components/PreCloseSection';
import { WhatYouReceiveSection } from '../components/WhatYouReceiveSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { LegalFooter } from '../components/LegalFooter';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    __fbPixelReady: boolean;
  }
}
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-[#2D1F0E]" data-id="element-239">
      <HeroSection data-id="element-240" />
      <ProblemSection data-id="element-241" />
      <MechanismSection data-id="element-242" />
      <WhatYouGetSection data-id="element-243" />
      <CredibilitySection data-id="element-244" />
      <AudienceSection data-id="element-245" />
      <TransformationSection data-id="element-246" />
      <FAQSection data-id="element-247" />
      <ExpectationNoteSection data-id="element-248" />
      <PreCloseSection data-id="element-249" />
      <WhatYouReceiveSection data-id="element-250" />
      <TestimonialsSection data-id="element-251" />
      <OfferSection data-id="element-252" />
      <LegalFooter data-id="element-253" />
    </main>;
}